import { Container, Title, SubTitle, Image } from './Styles';
import wheresMyCode from 'assets/wheres_my_code.png';

const WheresMyCode = () => {
  return (
    <Container>
      <Title>How to find your code?</Title>
      <SubTitle>You can find the code at the bottom right side of the settings panel</SubTitle>
      <Image src={wheresMyCode} />
    </Container>
  );
};

export default WheresMyCode;
